import { render, staticRenderFns } from "./ImageDefault.vue?vue&type=template&id=21ae77bc&"
import script from "./ImageDefault.vue?vue&type=script&lang=js&"
export * from "./ImageDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports